var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h4',{staticClass:"assigned-to"},[_c('b',[_vm._v(_vm._s(_vm.pLabel)+":")]),_c('span',[_vm._v(_vm._s(_vm.pName))]),_c('span',[_c('b-skeleton',{attrs:{"active":_vm.pLoading,"width":"120"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }